import React from 'react'
import { makeStyles } from '@krowdy/kds-core'

const ViewError = ({ title = 'Not Found' }) => {
  const classes = useStyles()

  return (
    <div className={classes.pageNot}>
      {/* <ImageBee alt='' src='https://cdn.krowdy.com/media/images/krowdy-empty.svg' /> */}
      {title}
    </div>
  )
}

const useStyles = makeStyles(() => ({
  pageNot: {
    fontSize  : 18,
    fontWeight: 500,
    marginTop : 12,
    textAlign : 'center'
  }
}))

export default ViewError
